import { render, staticRenderFns } from "./AccidentIntakeSymptomsTodayForm.vue?vue&type=template&id=f6212cd4&scoped=true"
import script from "./AccidentIntakeSymptomsTodayForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeSymptomsTodayForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeSymptomsTodayForm.vue?vue&type=style&index=0&id=f6212cd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6212cd4",
  null
  
)

export default component.exports